(function ($) {
  // hamburger menu
  // all HTML, CSS and jQuery code for the menu is heavily modified from (but still based on) http://www.jqueryscript.net/menu/jQuery-CSS3-Based-Expanding-Hamburger-Menu-Shy-Menu.html

  var mojHamburger = {};

  jQuery(function () {
    mojHamburger.initDropDowns = function (allMenus) {
      allMenus.children(".menu-hamburger").on("click", function () {
        var thisTrigger = jQuery(this),
          thisMenu = thisTrigger.parent(),
          thisPanel = thisTrigger.next();
        //alert(thisMenu.attr('class'));

        if (thisMenu.hasClass("is-open")) {
          thisMenu.find(".menu-panel").hide(); // close nav back up
          thisMenu.find(".home-link").removeClass("no-vis"); // show the home link again (SUBSITE ONLY!)
          thisMenu.removeClass("is-open");
          /*jQuery(document).off("click");
					thisPanel.off("click");*/
        } else {
          thisMenu.find(".menu-panel").show(); // drop down the nav on click
          thisMenu.find(".home-link").addClass("no-vis"); // hide the home link (SUBSITE ONLY!)
          allMenus.removeClass("is-open");
          thisMenu.addClass("is-open");
          /*jQuery(document).on("click", function() {
						allMenus.removeClass("is-open");
					});*/
          thisPanel.on("click", function (e) {
            e.stopPropagation();
          });
        }

        return false;
      });
    };

    mojHamburger.initDropDowns(jQuery("header.toolbar .container")); // "nav.menu"
  });

  // ----- sub-level open/close toggler -----
  // *very heavily* modified code from http://www.noupe.com/inspiration/tutorials-inspiration/drop-down-menu-jquery-css.html

  function mobileMenuChildrenExpandCollapse(toggle) {
    if (jQuery(toggle).hasClass("sub-open")) {
      jQuery(toggle).parent().find("ul.nav-list:first").slideUp("slow").show(); // move nav back up
      jQuery(toggle).removeClass("sub-open");
      jQuery(toggle).html("+");
    } else {
      var linkID = $(toggle).data("link-id");
      if (linkID) {
        fetchChildren(linkID, $(toggle));
      }
      jQuery(toggle)
        .parent()
        .find("ul.nav-list:first")
        .slideDown("medium")
        .show(); // drop down the subnav
      jQuery(toggle).addClass("sub-open");
      jQuery(toggle).html("-");
    }
  }

  async function fetchChildren(linkID, $element) {
    if ($element.parent().children(".nav-list__children-placeholder").length) {
      const response = await fetch(`/menu-fragment/index/${linkID}`, {
        headers: {
          "X-Requested-With": "XMLHttpRequest",
        },
      });
      const json = await response.text();

      $element.parent().find(".nav-list__children-placeholder").replaceWith(json);
      $element.parent().find("ul.nav-list:first").slideDown("medium");
      $element.addClass("sub-open");
      $element.html("-");
      jQuery(".menu-panel ul li .toggleNav")
        .unbind("click")
        .bind("click", function () {
          mobileMenuChildrenExpandCollapse(this);
        });
    }
  }

  jQuery(function () {
    jQuery(".menu-panel ul li .toggleNav").on("click", function () {
      mobileMenuChildrenExpandCollapse(this);
    });

    //inject title to youtube video frame
    $("iframe").each(function () {
      if (!$(this).attr("title")) {
        $(this).attr(
          "title",
          "youtube_" + Math.random().toString(36).substr(2, 9)
        );
      }
    });
  });
})(jQuery);
